import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { formatDate } from '@/lib/utils';
import { MonitoringAlert } from '../types/monitoring';

const levelConfig = {
  info: { label: 'Info', variant: 'secondary' as const },
  warning: { label: 'Warning', variant: 'warning' as const },
  critical: { label: 'Critical', variant: 'destructive' as const },
};

interface AlertsListProps {
  alerts: MonitoringAlert[];
}

export default function AlertsList({ alerts }: AlertsListProps) {
  if (alerts.length === 0) {
    return (
      <div className="rounded-lg border bg-card p-6 text-center text-sm text-muted-foreground">
        No active alerts.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {alerts.map((alert) => {
        const config = levelConfig[alert.level];
        return (
          <div
            key={alert.id}
            className="flex items-start gap-3 rounded-lg border bg-card p-4 shadow-sm"
          >
            <AlertTriangle className="mt-0.5 h-4 w-4 text-muted-foreground" />
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <Badge variant={config.variant}>{config.label}</Badge>
                <span className="text-xs text-muted-foreground">
                  {formatDate(alert.createdAt)}
                </span>
              </div>
              <p className="mt-2 text-sm">{alert.message}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
